<template>
  <AttachmentPreviewContainer
    type="Form"
    :title="attachment.data.form.title"
    :info="attachment.data.createdLabel"
    icon="forms"
    @remove="$emit('remove')"
  />
</template>

<script setup lang="ts">
import AttachmentPreviewContainer from '../../preview/Container.vue'

interface Props {
  attachment: Record<string, any>
}

defineProps<Props>()

const emit = defineEmits<{
  (e: 'remove'): void
}>()
</script>
